import { AnyAction } from "redux";
import { SagaIterator } from "redux-saga";
import { put, takeLatest } from "typed-redux-saga";

import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { requestEditableAction } from "./actions";
import { revokeEditChangesEvent } from "./editAntrag/cancelAntragEditSaga";

/**
 * Horcht auf relevante Actions (changeScreen, openTaskDocument) und löst dann die "requestEditable"-Action aus,
 * um zu überprüfen, ob das Formular editierbar gemacht werden kann.
 */
export function* setFormEngineInitiallyReadonlySaga(): SagaIterator<void> {
	yield* takeLatest(
		(action: AnyAction) => {
			return (
				(FormEngineActions.command.match(action) && Commands.changeScreen.match(action.payload.engineEvent)) ||
				(FormEngineActions.event.match(action) &&
					action.payload.engineEvent?.payload?.name === revokeEditChangesEvent)
			);
		},
		function* handle() {
			yield* put(requestEditableAction({}));
		}
	);
}
